import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

// 静态路由：只保留登录、404和基础Layout
export const constantRoutes = [
    {
        path: '/',
        redirect: '/pc',
        hidden: true
    },
    {
        path: '/login',
        component: () => import('@/views/login/index.vue'),
        hidden: true
    },
    {
        path: '/pc/login',
        name: 'PcLogin',
        component: () => import('@/views/pc/login.vue'),
        hidden: true
    },
    {
        path: '/pc/newcomer-campaign',
        name: 'PcNewcomerCampaign',
        component: () => import('@/views/pc/newcomer-campaign.vue'),
        hidden: true
    },
    {
        path: '/pc',
        component: () => import('@/views/pc/layout.vue'),
        hidden: true,
        children: [
            {
                path: '',
                name: 'PcHome',
                component: () => import('@/views/pc/home.vue')
            },
            {
                path: 'products',
                name: 'PcProductList',
                component: () => import('@/views/pc/product-list.vue')
            },
            {
                path: 'sourcing',
                name: 'PcSourcing',
                component: () => import('@/views/pc/sourcing.vue')
            },
            {
                path: 'member/sourcing',
                name: 'PcMemberSourcing',
                component: () => import('@/views/pc/member-center.vue')
            },
            {
                path: 'product/:code',
                name: 'PcProductDetail',
                component: () => import('@/views/pc/product-detail.vue')
            },
            {
                path: 'cart',
                name: 'PcCart',
                component: () => import('@/views/pc/cart.vue')
            },
            {
                path: 'checkout',
                name: 'PcCheckout',
                component: () => import('@/views/pc/checkout.vue')
            },
            {
                path: 'member',
                name: 'PcMemberCenter',
                component: () => import('@/views/pc/member-center.vue')
            },
            {
                path: 'member/profile',
                name: 'PcMemberProfile',
                component: () => import('@/views/pc/member-center.vue')
            },
            {
                path: 'member/addresses',
                name: 'PcMemberAddresses',
                component: () => import('@/views/pc/member-center.vue')
            },
            {
                path: 'member/orders',
                name: 'PcMemberOrders',
                component: () => import('@/views/pc/member-center.vue')
            },
            {
                path: 'member/boms',
                name: 'PcMemberBoms',
                component: () => import('@/views/pc/member-center.vue')
            },
            {
                path: 'member/invoices',
                name: 'PcMemberInvoices',
                component: () => import('@/views/pc/member-center.vue')
            },
            {
                path: 'member/invoice-records',
                name: 'PcMemberInvoiceRecords',
                component: () => import('@/views/pc/member-center.vue')
            },
            {
                path: 'member/invoice-profiles',
                name: 'PcMemberInvoiceProfiles',
                component: () => import('@/views/pc/member-center.vue')
            },
            {
                path: 'member/points/exchanges',
                name: 'PcMemberPointExchanges',
                component: () => import('@/views/pc/member-center.vue')
            },
            {
                path: 'member/coupons',
                name: 'PcMemberCoupons',
                component: () => import('@/views/pc/member-center.vue')
            },
            {
                path: 'member/points/details',
                name: 'PcMemberPointDetails',
                component: () => import('@/views/pc/member-center.vue')
            },
            {
                path: 'member/points/rules',
                name: 'PcMemberPointRules',
                component: () => import('@/views/pc/member-center.vue')
            },
            {
                path: 'bom',
                name: 'PcBomMatch',
                component: () => import('@/views/pc/bom-match.vue')
            },
            {
                path: 'points',
                name: 'PcPointsMall',
                component: () => import('@/views/pc/points-mall.vue')
            },
            {
                path: 'news',
                name: 'PcNewsList',
                component: () => import('@/views/pc/news-list.vue')
            },
            {
                path: 'news/:code',
                name: 'PcNewsDetail',
                component: () => import('@/views/pc/news-detail.vue')
            },
            {
                path: 'videos',
                name: 'PcVideoList',
                component: () => import('@/views/pc/video-list.vue')
            },
            {
                path: 'video/:code',
                name: 'PcVideoDetail',
                component: () => import('@/views/pc/video-detail.vue')
            }
        ]
    },
    {
        path: '/dashboard',
        component: Layout,
        hidden: true,
        children: [
            {
                path: '',
                name: 'AdminDashboard',
                component: () => import('@/views/dashboard/index.vue')
            }
        ]
    },
    {
        path: '/analytics',
        component: Layout,
        hidden: true,
        children: [
            {
                path: 'activity',
                name: 'AnalyticsActivity',
                component: () => import('@/views/analytics/activity/index.vue')
            },
            {
                path: 'search-ranking',
                name: 'AnalyticsSearchRanking',
                component: () => import('@/views/analytics/search-ranking/index.vue')
            }
        ]
    },
    {
        path: '/admin',
        component: Layout,
        hidden: true
    },

    {
        path: '/404',
        component: () => import('@/views/error/404.vue'),
        hidden: true
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: constantRoutes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

export default router
